module.exports = {
          srcSet: __webpack_public_path__ + "10b895b63c014d2c43a3792df93615eb-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "10b895b63c014d2c43a3792df93615eb-1920.png",width: 1920,height: 538}],
          src: __webpack_public_path__ + "10b895b63c014d2c43a3792df93615eb-1920.png",
          toString:function(){return __webpack_public_path__ + "10b895b63c014d2c43a3792df93615eb-1920.png"},
          
          width: 1920,
          height: 538
        }